<template>
    <div class="container mt-3">
        <div class="new-create">
            <div class="row">
                <div class="col-md-12 new-background mb-5">

                    <h1 class="mb-4 mt-4 new-heading" v-if="!membership">Update Membership</h1>
                    <h1 class="mb-4 mt-4 new-heading" v-if="membership">Add Membership</h1>

                    <form>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>User ID</b></label>
                                    <input type="text"
                                           class="form-control"
                                           placeholder="Enter User ID"
                                           v-model="membershipAdd.user_id" required>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>User Type</b></label>
                                    <input type="text"
                                           class="form-control"
                                           placeholder="Enter User Type"
                                           v-model="membershipAdd.user_type" required>
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-3">
                            <label><b>Membership Title</b></label>
                            <input type="text" class="form-control"
                                   placeholder="Enter Title"
                                   v-model="membershipAdd.title"
                                   required name="title"
                                   v-validate="'required|max:255'">
                            <small v-if="errors.has('title')" class="text-danger">
                                {{ errors.first('title') }}
                            </small>
                        </div>
                        <div class="form-group mb-3">
                            <label><b>Membership Text</b></label>
                            <editor v-model="membershipAdd.text" v-validate="'required|min:10'"
                                    name="text"
                                    api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                    data-vv-as="news description"
                                    required></editor>
                            <small v-if="errors.has('text')" class="text-danger">
                                {{ errors.first('text') }}
                            </small>
                        </div>


                        <div class="mb-5 mt-3">
                            <button type="button"
                                    class="btn btn-primary"
                                    v-if="!membership"
                                    @click="update_membership()">UPDATE
                            </button>
                            <button type="button" class="btn btn-primary" v-if="membership" @click="add_membership()">ADD
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";

export default {
  name: "CreateMemberships",
  components: { Editor },
  data() {
    return {
      membershipAdd: {},
      membership: true
    };
  },
  methods: {
    add_membership: function() {
      this.membershipAdd.access_token = localStorage.getItem("access_token");
      this.membershipAdd.admin_id = localStorage.getItem("admin_id");
      axios({
        method: "POST",
        url: "admin/memberships/new",
        data: this.membershipAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("Membership Added Successfully", "", "success");
            window.location.href = "/dashboard/website/memberships";
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          error;
        }
      );
    },
    getsingleMembership() {
      axios({
        url:
          "/admin/memberships/" +
          this.$route.params.membership_id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.membershipAdd = result.data.membership;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    update_membership: function() {
      this.membershipAdd.access_token = localStorage.getItem("access_token");
      axios({
        method: "PUT",
        url: "/admin/memberships/update/" + this.$route.params.membership_id,
        data: this.membershipAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("Membership Updated Successfully", "", "success");
            window.location.href = "/dashboard/website/memberships";
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          error;
        }
      );
    }
  },
  mounted: function() {
    if (this.$route.params.membership_id > 0) {
      this.membership = false;
      this.getsingleMembership();
    } else {
      this.membershipAdd = {};
      this.membership = true;
    }
  }
};
</script>

<style lang="scss">
.new-create {
  padding-right: 20px;
  padding-left: 20px;
  .new-heading {
    font-size: 35px;
  }
  .form-control:focus {
    box-shadow: 0 0 0 0.2rem rgb(255, 255, 255);
  }
  .new-background {
    border-radius: 4px;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.08);
    border: solid 0.5px #e8ebf2;
    background-color: #ffffff;
  }
}
</style>
